export const ENABLE_MENU = "ENABLE_MENU";

export const enableMenu = (menuType, enableState) => {
  return {
    type: ENABLE_MENU,
    menuType: menuType,
    enableState: enableState
  };
};



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/mapbuttons/actions.js